module.exports = __webpack_public_path__ + "98c59910.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/volume-up.png
// module id = 1163
// module chunks = 0 1 2